var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqQ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1276,
    cy: 15,
    rx: 15.1276,
    ry: 15,
    fill: "#657FD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5002 14.3462C19.5002 15.0655 19.4085 15.7199 19.2249 16.3092C19.0501 16.8899 18.7792 17.3925 18.4121 17.8172C18.0537 18.2419 17.5948 18.5625 17.0355 18.7792L19.2905 21.2102H17.0617L15.318 19.1302C15.283 19.1302 15.2437 19.1302 15.2 19.1302C15.165 19.1302 15.1301 19.1302 15.0951 19.1302C14.3434 19.1302 13.6879 19.0175 13.1285 18.7922C12.5779 18.5582 12.1234 18.2332 11.765 17.8172C11.4067 17.3925 11.1357 16.8855 10.9522 16.2962C10.7773 15.7069 10.6899 15.0525 10.6899 14.3332C10.6899 13.3712 10.8473 12.5349 11.1619 11.8242C11.4853 11.1135 11.9704 10.5632 12.6172 10.1732C13.2727 9.77453 14.1031 9.5752 15.1082 9.5752C16.0959 9.5752 16.9131 9.77453 17.5599 10.1732C18.2067 10.5632 18.6918 11.1179 19.0152 11.8372C19.3385 12.5479 19.5002 13.3842 19.5002 14.3462ZM12.4599 14.3462C12.4599 15.0482 12.5516 15.6505 12.7352 16.1532C12.9275 16.6559 13.2159 17.0415 13.6005 17.3102C13.9938 17.5789 14.492 17.7132 15.0951 17.7132C15.7157 17.7132 16.2182 17.5789 16.6028 17.3102C16.9874 17.0415 17.2714 16.6559 17.455 16.1532C17.6385 15.6505 17.7303 15.0482 17.7303 14.3462C17.7303 13.2975 17.5249 12.4742 17.1141 11.8762C16.7033 11.2782 16.0347 10.9792 15.1082 10.9792C14.4964 10.9792 13.9938 11.1135 13.6005 11.3822C13.2159 11.6509 12.9275 12.0365 12.7352 12.5392C12.5516 13.0419 12.4599 13.6442 12.4599 14.3462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqQ);
export default __webpack_public_path__ + "static/media/faq_q.10cee94472c4b9f31eaae9347dbe52a0.svg";
export { ForwardRef as ReactComponent };